<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Редактирование карточки</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout wrap>
            <v-flex xs8>
              <v-text-field
                      placeholder="Название карточки"
                      persistent-hint
                      class="kanban-section-input"
                      v-model="card.name"
              ></v-text-field>
              <v-textarea
                      label="Описание карточки"
                      rows="4"
                      class="kanban-card-edit-textarea"
                      v-model="card.description"
              ></v-textarea>
            </v-flex>
            <v-flex xs4 pl-4>
              <v-btn block class="kanban-btn-cancel" @click="">Исполнители</v-btn>
              <v-btn block class="kanban-btn-cancel" @click="">Метки</v-btn>
              <v-btn block class="kanban-btn-cancel" @click="">Срок</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="kanban-btn-cancel" @click="dialog = false">Закрыть</v-btn>
        <v-btn class="kanban-btn-ok" @click="ok()">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {

  name: 'DCardEditDialog',

  componentName: "DCardEditDialog",

  /**
   *
   *
   */
  props: {

    editCard: {
      type: Object,
      required: false
    }
  },

  /**
   *
   *
   */
  mounted() {

  },

  /**
   *
   *
   */
  data() {

    return {

      dialog: false,

      card: {},
    }
  },

  /**
   *
   *
   */
  watch: {

  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     *
     *
     */
    show() {

      this.card = Object.assign( {}, this.editCard )

      this.dialog = true
    },

    /**
     *
     *
     */
    hide() {

      this.dialog = false
    },

    /**
     *
     *
     */
    ok() {

      this.dialog = false

      this.$emit( 'ok', this.card )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/DKanban/src/DCardEditDialog.vue